module.exports = __webpack_public_path__ + "img/RoseRowland.08f9dc31.jpg";